var _defs, _circle, _path, _path2, _rect, _g, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "frame_1_3_miroir",
    "data-name": "frame 1 & 3 miroir",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-340 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbbcaa;}.cls-2{fill:#20456e;}.cls-3{fill:#173856;}.cls-4{fill:#639;}.cls-5{fill:#442114;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Frame 1 miroir") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 169,
    cy: 204.63,
    r: 169
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1072.7,1252.5v-203s0-50-66-50-66,40-66,40v213Z",
    transform: "translate(-837.7 -625.87)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1073.2,1252s-12,114-11.29,208.57c12.86,5.54,9.57,81.43,9.57,81.43l-170.57,1.65s-10.39-64.36,51.08-70.55C942.64,1419,939.2,1323,940.2,1252,986.2,1253,1073.2,1252,1073.2,1252Z",
    transform: "translate(-837.7 -625.87)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 940.2,
    y: 1244,
    width: 133,
    height: 8,
    transform: "translate(1175.7 1870.13) rotate(-180)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bras_arri\\xE8re",
    "data-name": "bras arri\\xE8re"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1037.87,1250.43s13.27,74-30,66.51S981.65,1244,981.65,1244Z",
    transform: "translate(-837.7 -625.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1050,1060.78s-31.09-79.29-86.08-22.68l4,212.58s43.07,18.85,78,3.72C1049.21,1179.18,1050,1060.78,1050,1060.78Z",
    transform: "translate(-837.7 -625.87)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1040.31,1004.55c-8.6-3.4-19.44-5.55-33.11-5.55-66,0-68,40-68,40S954.2,1014,1040.31,1004.55Z",
    transform: "translate(-837.7 -625.87)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1046.2,915l10,77.13C1072.77,1006.48,1236.91,964,1200,775c-2.6-13.31-14-39-29-65,46,0,86,218,160,260,60.69-74,70.11-364.45-110-343-21,3-60,34-63.78,67.17C1115.33,654.5,1052,643.62,996.2,648c-26.27,2.06-70.79,18.2-101,41a196,196,0,0,0-49,55C829,778,868,832.28,958,805c13.92,34.16,29.92,57,49.2,62,0,0,27.67-26.15,54-14C1087.2,865,1081.2,919,1046.2,915Z",
    transform: "translate(-837.7 -625.87)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftFrame1);
export default __webpack_public_path__ + "static/media/left_frame_1.5a8de7a9bee3b733c1c1f0923ba3c9a6.svg";
export { ForwardRef as ReactComponent };